import { getSelectedState } from '@product-details/store/selectors/selected.selector';
import { isDisposalSelected, isInstallationSelected } from './extras.selector';
import { Description, Service } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createSelector } from '@ngrx/store';

// TODO dependency
const getSelectedOffer = createSelector(
  getSelectedState,
  (state) => state?.data
);

export const getDelivery = createSelector(
  getSelectedOffer,
  (offer: ReplacementOffer) => {
    return (
      offer?.services?.filter(
        (service) => service.description === Description.Delivery
      )[0] || null
    );
  }
);

export const isDeliveryAvailable = createSelector(
  getDelivery,
  (service: Service) => {
    return !!service;
  }
);

export const getInstallation = createSelector(
  getSelectedOffer,
  (offer: ReplacementOffer) => {
    return offer?.services?.filter(
      (service) => service.description === Description.Installation
    )[0];
  }
);

export const isInstallationAvailable = createSelector(
  getInstallation,
  (service: Service) => {
    return !!service;
  }
);

export const getDisposal = createSelector(
  getSelectedOffer,
  (offer: ReplacementOffer) => {
    return offer?.services?.filter(
      (service) => service.description === Description.Disposal
    )[0];
  }
);

export const isDisposalAvailable = createSelector(
  getDisposal,
  (service: Service) => {
    return !!service;
  }
);

export const isInstallationUpsellAvailable = createSelector(
  [isInstallationSelected, isInstallationAvailable],
  (selected, available) => {
    return !selected && available;
  }
);

export const isDisposalUpsellAvailable = createSelector(
  [isDisposalSelected, isDisposalAvailable],
  (selected, available) => {
    return !selected && available;
  }
);

export const isUpsellAvailable = createSelector(
  [isInstallationUpsellAvailable, isDisposalUpsellAvailable],
  (installation, disposal) => {
    return installation || disposal;
  }
);
